'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { FILTER_TYPES_OTHER, mapAcad021Categories, mapSoftwareFiltersWithAll } from '../constants/TopFilterConstants';
import UsageTracker from '../utils/UsageTracker';
import { useSearchParamSingleSelect } from '../hooks/searchParamHooks';
import useMediaQuery from '../hooks/useMediaQuery';
import { device } from '../constants/StyledComponentConstants';
import { useImmutableFilters } from '../features/filters/filtersQueries';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const DropdownButton = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    use: "link",
    children: /*#__PURE__*/_jsx(Text, {
      color: "text-core-on-fill-default",
      typography: "heading-50",
      children: children
    })
  }));
};
const CategoryGroupDropdown = ({
  selectedCategory,
  selectedGroup,
  filterType
}) => {
  const [__, setCatalogFilter] = useSearchParamSingleSelect();
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const {
    filters
  } = useImmutableFilters();
  const groupCategories = filterType === FILTER_TYPES_OTHER.CATEGORIES ? mapAcad021Categories(filters.subCategories).get(selectedGroup) : mapSoftwareFiltersWithAll(filters.hsSoftwareFilters).get(selectedGroup);
  const trackFilterSelect = selectedOption => {
    UsageTracker.track('filterInteraction', {
      action: 'filter-selected',
      value: selectedOption,
      key: filterType,
      isDropdown: true
    });
  };
  const onClickOption = selectedOption => {
    setCatalogFilter(filterType, selectedOption);
    trackFilterSelect(selectedOption);
  };
  const getSelectedCategory = () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: `learningCenter.topFilters.${filterType}.${selectedCategory}`
  });
  const getDropdownOptions = () => groupCategories.map(cat => /*#__PURE__*/_jsx(Button, {
    onClick: () => {
      onClickOption(cat);
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.topFilters.${filterType}.${cat}`
    })
  }, cat));
  return groupCategories && groupCategories.size > 0 ? /*#__PURE__*/_jsx(Dropdown, {
    Button: !isMobile ? DropdownButton : undefined,
    arrowSize: "none",
    buttonText: getSelectedCategory(),
    buttonUse: !isMobile ? 'link-on-dark' : 'link',
    paddingInline: "0",
    children: /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: getDropdownOptions()
    })
  }) : getSelectedCategory();
};
CategoryGroupDropdown.propTypes = {
  filterType: PropTypes.string,
  selectedCategory: PropTypes.string,
  selectedGroup: PropTypes.string
};
export default CategoryGroupDropdown;